import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { EditApplicantStatus } from "common/models/page-models/applicants/applicant-table/applicant-filter-data.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";


 
@Injectable()
export class editStudentDataService extends DataService<EditApplicantStatus> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.editStudentStatusChanges,http);
    }
 
 
//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
   
    createInstance(): EditApplicantStatus {
        return new EditApplicantStatus();
    }

    
 
}